import React from 'react';
import { observer } from 'mobx-react';
import { Utils } from 'Utils/utils';
import * as CONSTANTS from 'Utils/constants';
import jobChangeIcon from 'Assets/png/jobChangePopUp.png';
import { ReactComponent as LocationIcon } from 'Assets/svg/location.svg';
import { ReactComponent as OrganizationIcon } from 'Assets/svg/organization.svg';
import * as ArrowIcon from 'Assets/lottieJSON/pointer.json';
import Lottie from 'react-lottie';
import { ReactComponent as MoveToIcon } from 'Assets/svg/move-to-icon.svg';
import { ReactComponent as EmptyCompanyLogo } from 'Assets/svg/empty-company-logo.svg';
import { ReactComponent as UpdatesIcon } from 'Assets/svg/updates-red-icon.svg';
import { LazyImage } from 'Components/common/lazyImage';
import { CompanyName } from 'Components/common/CompanyList/companyName';
import { CompanyLocation } from 'Components/common/CompanyList/companyLocation';
import { SocialLinks } from 'Components/common/SocialLinks';
import { CompanyWebsite } from 'Components/common/CompanyList/companyWebsite';
import Dropdown from 'Components/common/dropdown';
import userDetail from 'Stores/userDetail';
import { PhoneItem } from 'Components/common/ContactList/ContactPhone';

const defaultOptions = {
  loop: true,
  autoplay: true,
  animationData: ArrowIcon.default,
  rendererSettings: {
    preserveAspectRatio: 'xMidYMid slice',
  },
};

const CompanyCard = observer(props => {
  const { companyCardData, showCompanyCardLoading } = props;
  const {
    name,
    logoUrl,
    // industry,
    // revenue,
    // employeeCount,
    website,
    city,
    state,
    country,
  } = companyCardData;

  const CompanyCardInfoDataLoadingPlaceHolder = () => {
    return (
      <div className="contact-card company-card loading-placeholder">
        <span className="sharp-point" />
        <div className="contact-card-details">
          <div className="basic-info-wrapper">
            <div className="company-logo-wrapper linear-background" />
            <div className="company-name-location-wrap">
              <CompanyName parentClass="linear-background" />
              <div className="company-phone-location">
                <CompanyLocation city="loading" clsName="linear-background" />
              </div>
            </div>
          </div>
          <div className="additional-info-wrapper">
            <CompanyWebsite
              primaryDomain="loading"
              clsName="linear-background"
            />
          </div>
        </div>
      </div>
    );
  };

  const CompanyCardInfoData = () => {
    return (
      <div className="contact-card company-card">
        <span className="sharp-point" />
        <div className="contact-card-details">
          <div className="basic-info-wrapper">
            {logoUrl ? (
              <LazyImage
                alt={name}
                src={logoUrl}
                clsName="logo"
                threshold={200}
                parentClass="company-logo-wrapper"
              />
            ) : (
              <div className="company-logo-wrap">
                <EmptyCompanyLogo className="empty-company-logo" />
              </div>
            )}
            <div className="company-name-location-wrap">
              <CompanyName name={name} />
              <div className="company-phone-location">
                <CompanyLocation city={city} state={state} country={country} />
              </div>
            </div>
          </div>
          <div className="additional-info-wrapper">
            <CompanyWebsite primaryDomain={website} />
          </div>
          <SocialLinks
            facebookId={companyCardData?.facebookURL}
            twitterId={companyCardData?.twitterURL}
            youtubeId={companyCardData?.youtubeURL}
            linkedInId={companyCardData?.linkedinURL}
          />
        </div>
      </div>
    );
  };

  return showCompanyCardLoading ? (
    <CompanyCardInfoDataLoadingPlaceHolder />
  ) : (
    <CompanyCardInfoData />
  );
});

const ContactCompany = observer(props => {
  const {
    cname,
    companyLogo = null,
    previousCompanyLogo = null,
    companyCountry,
    companyState,
    companyCity,
    companyId,
    currentTab = null,
    movedDifferentTag = null,
    previousCompany = null,
    previousCompanyId = null,
    companyPhone,
    company,
  } = props;

  let companyStr = '';
  if (companyCity) companyStr += companyCity;
  if (companyState)
    if (companyStr !== '') companyStr += `, ${companyState}`;
    else companyStr += companyState;
  if (companyCountry)
    if (companyStr !== '') companyStr += `, ${companyCountry}`;
    else companyStr += companyCountry;

  const onMouserEnterCompanyCard = id => {
    window.timeoutVar = setTimeout(async () => {
      Utils.mixpanelTrack(
        CONSTANTS.MX_ML_EVENTS.ML_RESULT_HOVER_COMPANY_NAME,
        {},
      );
    }, 500);
  };

  const onMouserLeaveCompanyCard = e => {
    if (window.timeoutVar !== undefined) clearTimeout(window.timeoutVar);
  };

  return cname ? (
    <div className="company-name">
      {companyId ? (
        <>
          <div>
            {currentTab !== 1 && (
              <div
                onMouseEnter={e => onMouserEnterCompanyCard(companyId)}
                onMouseLeave={e => onMouserLeaveCompanyCard()}
              >
                <Dropdown
                  toggleElement={
                    <div className="name company-name-text">
                      {companyLogo ? (
                        <LazyImage
                          alt={cname}
                          src={companyLogo}
                          clsName="logo"
                          threshold={200}
                          parentClass="company-logo-wrap"
                        />
                      ) : (
                        <div className="company-logo-wrap">
                          <EmptyCompanyLogo className="empty-company-logo" />
                        </div>
                      )}
                    </div>
                  }
                  dropdownHeight={250}
                  showOnHover
                >
                  {Object.keys(company).length > 0 && (
                    <CompanyCard companyCardData={company} />
                  )}
                </Dropdown>
              </div>
            )}
            {currentTab === 1 && (
              <div className="company-change-wrap">
                {previousCompanyLogo && previousCompanyId ? (
                  <div
                    onMouseEnter={e =>
                      onMouserEnterCompanyCard(previousCompanyId)
                    }
                    onMouseLeave={e => onMouserLeaveCompanyCard(e)}
                  >
                    <Dropdown
                      toggleElement={
                        <div className="name company-name-text">
                          <LazyImage
                            alt={cname}
                            src={previousCompanyLogo}
                            clsName="logo"
                            threshold={200}
                            parentClass="company-logo-wrap"
                          />
                        </div>
                      }
                      dropdownHeight={250}
                      showOnHover
                    >
                      {Object.keys(company).length > 0 && (
                        <CompanyCard companyCardData={company} />
                      )}
                    </Dropdown>
                  </div>
                ) : (
                  <div className="company-logo-wrap">
                    <EmptyCompanyLogo className="empty-company-logo" />
                  </div>
                )}
                <span>
                  <MoveToIcon className="move-arrow" />
                </span>
                {companyLogo ? (
                  <div
                    onMouseEnter={e => onMouserEnterCompanyCard(companyId)}
                    onMouseLeave={e => onMouserLeaveCompanyCard(e)}
                  >
                    <Dropdown
                      toggleElement={
                        <div className="name company-name-text">
                          <LazyImage
                            alt={cname}
                            src={companyLogo}
                            clsName="logo"
                            threshold={200}
                            parentClass="company-logo-wrap"
                          />
                        </div>
                      }
                      dropdownHeight={250}
                      showOnHover
                    >
                      {Object.keys(company).length > 0 && (
                        <CompanyCard companyCardData={company} />
                      )}
                    </Dropdown>
                  </div>
                ) : (
                  <div className="company-logo-wrap">
                    <EmptyCompanyLogo className="empty-company-logo" />
                  </div>
                )}
              </div>
            )}
            <span className="name-location-wrap">
              <span className="company-name show-elipsis" title={cname}>
                {cname}
              </span>
              {companyStr && (
                <div className="company-location">
                  <LocationIcon />
                  <div
                    className="company-address-info show-elipsis"
                    title={companyStr}
                  >
                    {companyStr}
                  </div>
                </div>
              )}
              {companyPhone && (
                <div className="contact-phone">
                  <PhoneItem
                    type="company"
                    phoneNumber={companyPhone?.[0]?.number}
                    pageName="myleads"
                    Icon={OrganizationIcon}
                  />
                </div>
              )}
            </span>
          </div>
          {currentTab === 1 && previousCompany && (
            <div className="previous-title company-title">
              <span className="span-mr">Moved from</span>
              <span
                title={previousCompany}
                className="previous-company-name show-elipsis"
              >
                {previousCompany}
              </span>
            </div>
          )}
          {currentTab === 0 &&
            movedDifferentTag &&
            userDetail.isContactUpdatesEnabled && (
              <div className="updates-container-parent">
                <Dropdown
                  showOnHover
                  className="job-update-wrapper"
                  toggleElement={
                    <span className="updates-container">
                      <button
                        type="button"
                        className="btn moved-btn"
                        aria-label="Moved to a different company"
                      />
                    </span>
                  }
                >
                  <div className="available-updates-div move-to-different">
                    <div className=" role-changes-sharp-point job-changes-sharp-point" />
                    <div className="company-hover">
                      <span>
                        Check out the &quot;Job Changes&quot; tab to know more.
                      </span>
                      <span>
                        <img
                          className="job-change-img"
                          src={jobChangeIcon}
                          alt=""
                        />
                        <UpdatesIcon />
                        <div className="animated-pointer">
                          <Lottie
                            options={defaultOptions}
                            width={80}
                            height={62}
                            style={{ margin: 0 }}
                          />
                        </div>
                      </span>
                    </div>
                  </div>
                </Dropdown>
              </div>
            )}
        </>
      ) : (
        <div className="name">{cname}</div>
      )}
    </div>
  ) : (
    <div className="not-available-text">- NA -</div>
  );
});

export { ContactCompany };
export default ContactCompany;
